/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/



(function () {
const preorderIds = new Set([
  '48945717903454',
  '48945717936222',
  '48945718001758'
]);

  const productHandle =
    'masons-daughter-wilder-skirt-multi-paisley';

  function updatePreorderButton() {
    const path = window.location.pathname.replace(/\/$/, '');

    if (path !== '/products/' + productHandle) return;

    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    const variantInput = form.querySelector('[name="id"]');
    const button = form.querySelector('[data-add-to-cart]');
    const label = form.querySelector('[data-add-to-cart-text]');

    if (!variantInput || !button || !label) return;

    if (button.disabled) return;

    const isPreorder = preorderIds.has(
      String(variantInput.value)
    );

const notice = document.getElementById('wilder-preorder-notice');

if (notice) {
  notice.style.display = isPreorder ? 'block' : 'none';
}

    const desiredText = isPreorder
      ? 'Pre-Order'
      : 'Add to Cart';

    if (label.textContent.trim() !== desiredText) {
      label.textContent = desiredText;
    }
  }

  function startPreorderUpdates() {
    updatePreorderButton();

    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    // Detect changes to the selected variant.
    form.addEventListener('change', function () {
      requestAnimationFrame(updatePreorderButton);
    });

    // Detect changes made by Pipeline's theme scripts.
    const observer = new MutationObserver(function () {
      updatePreorderButton();
    });

    observer.observe(form, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener(
    'theme:variant:change',
    function () {
      requestAnimationFrame(updatePreorderButton);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startPreorderUpdates
    );
  } else {
    startPreorderUpdates();
  }
})();



(function () {
  const handle = 'masons-daughter-alexis-bodysuit-cocoa-dot';

  if (window.location.pathname.replace(/\/$/, '') !==
      '/products/' + handle) return;

  let inventory = {};

  function loadInventory() {
    const data = document.getElementById(
      'alexis-preorder-data'
    );

    if (!data) return;

    try {
      inventory = JSON.parse(data.textContent);
    } catch (error) {
      console.error('Alexis preorder data error:', error);
    }
  }

  function updateAlexisPreorder() {
    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    const input = form.querySelector('[name="id"]');
    const button = form.querySelector('[data-add-to-cart]');
    const label = form.querySelector(
      '[data-add-to-cart-text]'
    );
    const notice = document.getElementById(
      'alexis-preorder-notice'
    );

    if (!input || !button || !label) return;

    const variant = inventory[String(input.value)];

    const isPreorder = Boolean(
      variant &&
      variant.managed &&
      variant.policy === 'continue' &&
      variant.quantity <= 0
    );

    if (notice) {
      notice.style.display = isPreorder ? 'block' : 'none';
    }

    if (button.disabled) return;

    const desiredText = isPreorder
      ? 'Pre-Order'
      : 'Add to Cart';

    if (label.textContent.trim() !== desiredText) {
      label.textContent = desiredText;
    }
  }

  function start() {
    loadInventory();
    updateAlexisPreorder();

    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    form.addEventListener('change', function () {
      requestAnimationFrame(updateAlexisPreorder);
    });

    const observer = new MutationObserver(function () {
      updateAlexisPreorder();
    });

    observer.observe(form, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener(
    'theme:variant:change',
    function () {
      requestAnimationFrame(updateAlexisPreorder);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();




/* SAVANNAH DRESS — AUTOMATIC PREORDER */

(function () {
  const savannahIds = new Set([
    '48945708564574', // Small
    '48945708597342'  // Medium
  ]);

  const productHandle =
    'masons-daughter-savannah-dress-brown-jacquard';

  if (
    window.location.pathname.replace(/\/$/, '') !==
    '/products/' + productHandle
  ) return;

  let inventory = {};

  function loadInventory() {
    const data = document.getElementById(
      'savannah-preorder-data'
    );

    if (!data) return false;

    try {
      inventory = JSON.parse(data.textContent);
      return true;
    } catch (error) {
      console.error('Savannah inventory error:', error);
      return false;
    }
  }

  function updateButton() {
    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    const input = form.querySelector('[name="id"]');
    const button = form.querySelector('[data-add-to-cart]');
    const label = form.querySelector(
      '[data-add-to-cart-text]'
    );

    const notice = document.getElementById(
      'savannah-preorder-notice'
    );

    if (!input || !button || !label) return;

    const variantId = String(input.value);
    const variant = inventory[variantId];

    const isPreorder = Boolean(
      savannahIds.has(variantId) &&
      variant &&
      Boolean(variant.managed) &&
      variant.policy === 'continue' &&
      variant.quantity <= 0
    );

    if (notice) {
      notice.style.display = isPreorder
        ? 'block'
        : 'none';
    }

    if (button.disabled) return;

    const desiredText = isPreorder
      ? 'Pre-Order'
      : 'Add to Cart';

    if (label.textContent.trim() !== desiredText) {
      label.textContent = desiredText;
    }
  }

  function start() {
    if (!loadInventory()) return;

    const form = document.querySelector(
      'form[action*="/cart/add"]'
    );

    if (!form) return;

    updateButton();

    form.addEventListener('change', function () {
      requestAnimationFrame(updateButton);
    });

    const observer = new MutationObserver(function () {
      updateButton();
    });

    observer.observe(form, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  document.addEventListener(
    'theme:variant:change',
    function () {
      requestAnimationFrame(updateButton);
    }
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

